(function () {
  const script = document.currentScript;
  const dataTarget = script.getAttribute('data-target');

  const section = document.querySelector(dataTarget)
  const spaceBetween = section.classList.contains('bestseller__swiper--max')? 10 : 20

  const newSwiper = new Swiper(dataTarget, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: spaceBetween,

    navigation: {
      nextEl: '.swiper-button-next.bestseller__swiper-button-next',
      prevEl: '.swiper-button-prev.bestseller__swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination.bestseller__pagination',
      clickable: true
    },
  });
})();
